export default "skymp5-front/8640f075fec9377d988bb993224a2436.gif";